import React from "react";
import { transportCategories } from "../../components/search/categories";
import wagonIcon from "../../assets/images/transport-categories/wagon-icon.svg";
import wagonLightIcon from "../../assets/images/transport-categories/wagon-light-icon.svg";
import truckIcon from "../../assets/images/transport-categories/truck-icon.svg";
import specialIcon from "../../assets/images/transport-categories/special-icon.svg";
import roadTrainIcon from "../../assets/images/transport-categories/road-train-icon.svg";

/** Icon paths taken from the wireframes (24x24, stroke). */
export const D = {
  truck: "M2 5h12v13H2z M14 10h4l4 5v3h-8 M5 18a2 2 0 1 0 .01 0 M17 18a2 2 0 1 0 .01 0",
  box: "m12 3 9 5-9 5-9-5z M3 8v10l9 5 9-5V8 M12 13v10 M8 5l9 5",
  people: "M15 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M5 21v-3a7 7 0 0 1 14 0v3 M18 4a3 3 0 0 1 0 6 M21 20v-5",
  clock: "M21 13a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M12 7v6l4 3 M10 1h4",
  pin: "M19 9c0 6-7 12-7 12S5 15 5 9a7 7 0 1 1 14 0 M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
  close: "m7 7 10 10 M7 17 17 7",
  chevron: "m7 10 5 5 5-5",
  calendar: "M4 5h16v16H4z M4 10h16 M8 2v6 M16 2v6",
  search: "M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M15 15l6 6",
  locate: "M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0 M12 2v4 M12 18v4 M2 12h4 M18 12h4 M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  home: "M3 10 12 3l9 7 M5 9v12h5v-7h4v7h5V9",
  plus: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M12 8v8 M8 12h8",
  chat: "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7l-5 3V7a3 3 0 0 1 3-3 M8 9h7 M8 13h3",
  menu: "M4 6h16 M4 12h16 M4 18h16",
  gear: "m9 3 6 0 1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  doc: "M5 5h14v17H5z M5 10h14 M9 5V3h6v7 M12 10v4",
  check: "m5 12 4 4L19 6",
  building: "M5 21V3h10v18 M15 9h5v12 M3 21h18 M9 7h2 M9 11h2 M9 15h2 M17 13h1 M17 17h1",
};

export const Icon = ({ d, className = "icon" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d={d} />
  </svg>
);

const COLORS = ["#0063ff", "#16a34a", "#d97706", "#7c3aed", "#0891b2", "#db2777", "#475569"];

/** Round avatar with initials (replaces the wireframe's raster portrait). */
export function Portrait({ name }) {
  const words = String(name || "?").trim().split(/\s+/).slice(0, 2);
  const text = words.map((w) => w[0]).join("").toUpperCase();
  let h = 0;
  for (const ch of String(name)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return (
    <svg className="portrait" viewBox="0 0 44 43" role="img" aria-label={name}>
      <circle cx="22" cy="21.5" r="20" fill={COLORS[h % COLORS.length]} />
      <text x="22" y="27" textAnchor="middle" fontSize="15" fontWeight="700" fill="#fff" fontFamily="Inter, Arial, sans-serif">
        {text}
      </text>
    </svg>
  );
}

const CATEGORY_ICONS = { wagon: wagonIcon, "wagon-light": wagonLightIcon, truck: truckIcon, special: specialIcon, "road-train": roadTrainIcon };

/** Tile with the truck's category icon; the generic truck when the category is unknown (replaces the wireframe's raster vehicle photo). */
export function VehiclePhoto({ label, category }) {
  const known = transportCategories.find((c) => c.label === category);
  if (known)
    return (
      <span className="vehicle-photo is-category" role="img" aria-label={label} title={known.label}>
        <img src={CATEGORY_ICONS[known.className]} alt="" />
      </span>
    );
  return (
    <svg className="vehicle-photo" viewBox="0 0 52 45" role="img" aria-label={label}>
      <rect x="1" y="3" width="50" height="39" rx="9" fill="#eef4ff" />
      <g transform="translate(13 9.5) scale(1.1)" fill="none" stroke="#0063ff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d={D.truck} />
      </g>
    </svg>
  );
}
